import { render, staticRenderFns } from "./CoreWidgetExample.vue?vue&type=template&id=747f0b18&scoped=true"
import script from "./CoreWidgetExample.vue?vue&type=script&lang=js"
export * from "./CoreWidgetExample.vue?vue&type=script&lang=js"
import style0 from "./CoreWidgetExample.vue?vue&type=style&index=0&id=747f0b18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747f0b18",
  null
  
)

export default component.exports